export const isMobileDevice = () => {
	const mobileDeviceRegex = new RegExp(
		/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/,
		'i'
	);
	return mobileDeviceRegex.test(navigator.userAgent);
};

// For element positioning
export const isMobile = () => {
	return (
		isMobileDevice() &&
		window.screen.width < window.screen.height &&
		window.screen.width <= 760
	);
};
